function addItemToCart(event) {
  const button = event.target;

  if (!button.classList.contains('js-add-psbo')) {
    return;
  }

  let variantId = button.dataset.psboId;
  const parentVariantId = button.dataset.psboParent;
  const discountValue = button.dataset.psboValue;
  const discountPercent = button.dataset.psboPercent;
  const quantity = 1;

  if(variantId == '') {
    variantId = document.querySelector('#product_'+parentVariantId).value
  }

  document.querySelector('#cart-items').classList.add('pointer-events-none');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          quantity,
          id: variantId,
          properties: {
            '_psbo_new': parentVariantId,
            '_discountValue': discountValue,
            '_discountPercent': discountPercent
          }
        }
      ]
    })
  })
  .then(response => {
    if (document.querySelector('.cc-main-cart')) {
      location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
    }
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
  });
}

document.addEventListener('click', addItemToCart);